'use strict';

var App = require('app');

var RemoteControlToolbarView = Marionette.ItemView.extend({
    template: require('components/devices/templates/controller/remote_control_status'),
    statusData: {},
    serializeData: function () {
        return this.statusData;
    },
});

module.exports = RemoteControlToolbarView;
